<ng-container *ngIf="selectedRouteExpand">
    <div class="header">
        <div class="line boto close">
            <button class="boleta close" (click)="onClickBack($event)">
                <i class="fa fa-times-circle" aria-hidden="true"></i>
            </button>
        </div>

        <shared-trucking-route-header class="line" [route]="selectedRouteExpand"></shared-trucking-route-header>
        <div class="line bar baroptions">
            <actions [actionstrip]="actions" (clickAction)="onClickPreAction($event)">
            </actions>
        </div>
        <div class="line bar baroptions">
            <options class="mixed-text-icon" [optionstrip]="options" (clickOption)="onClickOption($event)">
            </options>
        </div>
    </div>

    <div class="body" (dragover)="dragover($event)" (drop)="dropAtZone($event)">
        <shared-trucking-route-panel-load *ngIf="actualOptionId==='LOAD'" class="subcomponent block-option"
            [selectedRouteExpand]="selectedRouteExpand">
        </shared-trucking-route-panel-load>

        <shared-active-slots-item *ngIf="actualOptionId==='ROUTE'" class="subcomponent noheader"
            [routeId]="selectedRouteExpand.routeId"></shared-active-slots-item>

        <shared-route-partner-selector *ngIf="actualOptionId==='PARTNERS'"
            class="subcomponent withoutexwork withoutexternaldriver ampladalimitada"
            [routeId]="selectedRouteExpand.routeId" [readonly]="true"></shared-route-partner-selector>

        <shared-driverplate *ngIf="actualOptionId==='DRIVER'" class="subcomponent block-option ampladalimitada"
            [showCarrierCard]="false" [onlydriver]="true" [routeId]="selectedRouteExpand.routeId"></shared-driverplate>

        <shared-chat *ngIf="actualOptionId==='CHAT'" class="subcomponent block-option"
            [forcedOwnerParticipant]="forcedOwnerParticipant" [notes]="true"
            (clickParticipant)="clickParticipant($event)">
        </shared-chat>

        <ng-container *ngIf="actualOptionId==='DOCUMENT'">

        </ng-container>

        <confirmation-dialog *ngIf="truckingAction" [expanded]="askingAction"
            helptitleresource="{{ truckingAction.titleResource }}" helpresource="{{ truckingAction.helpResource }}"
            (onConfirm)="onClickAction(truckingAction.action)" (onCancel)="askingAction = false"></confirmation-dialog>
    </div>
</ng-container>